import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'isophi-progress-doughnut-chart',
    templateUrl: './progress-doughnut-chart.component.html',
    styleUrls: ['./progress-doughnut-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgressChartComponent implements OnChanges {
  @Input() done = 0;
  @Input() watching = 0;
  @Input() total = 0;
  @Input() dark = false;
  @Input() showPercent = false;

  private readonly transloco = inject(TranslocoService);

  chartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [], borderWidth: 0, hoverBorderWidth: 0 }]
  };

  chartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    backgroundColor: '#F0F1F1',
    plugins: { legend: { display: false }, tooltip: { enabled: true } },
    cutout: '60%',
  };

  ngOnChanges(): void {
    if (this.total === 0) {
      this.total = 0.0001;
    }
    const remaining = Math.max(this.total - this.done - this.watching, 0);

    this.chartData = {
      labels: [
        this.transloco.translate('shared/finished'),
        this.transloco.translate('shared/watched'),
        this.transloco.translate('shared/rest')
      ],
      datasets: [{
        data: [this.done, this.watching, remaining],
        backgroundColor: ['#70dea3', '#E46A00', this.dark ? '#74797F' : '#00000014'],
        hoverBackgroundColor: ['#70dea3', '#E46A00', this.dark ? '#74797F' : '#00000014'],
        borderWidth: 0,
        hoverBorderWidth: 0,
      }]
    };

    this.chartOptions = {
      ...this.chartOptions,
      backgroundColor: this.dark ? '#74797F' : '#F0F1F1'
    };
  }

  get percent(): number {
    if (!this.total) return 0;
    return Math.round((this.done / this.total) * 100);
  }
}
